import React from 'react';
import './Footer.css';
import logo from '../../assets/logo.png'

const Footer = () => {
    return (
        <footer className="footer">
            <div className="logo">
                <img src={logo} alt='logo' />
            </div>
            <span style={{color:'rgba(157, 175, 189, 1)',fontSize:'13px',fontWeight:'300',marginTop:'5.29px'}}>Copyright © Easypoint.com.tr</span>
        </footer>
    );
};

export default Footer;
